import { useContext } from 'react';
import { Context } from './CreateNotice';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import DeleteNoticeIcon from './common/DeleteNoticeIcon';
import NoticeTypeIcon from './common/NoticeTypeIcons';
import rain from '../images/rain.svg';
import { NOTICE_CATEGORIES, NOTICE_TYPES, REASONS } from '../common/constants';

import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import AirIcon from '@mui/icons-material/Air';
import WaterIcon from '@mui/icons-material/Water';

const ReasonIcon = (props) => {
  const style = { color: 'jiyuu', width: '24px', height: '24px' };
  switch (props.code) {
    case REASONS.RAIN.value:
      return <Avatar src={rain} sx={style} />;
    case REASONS.WIND.value:
      return <AirIcon sx={style} />;
    case REASONS.FLOOD.value:
      return <WaterIcon sx={style} />;
  }
};

ReasonIcon.propTypes = {
  code: PropTypes.number,
};

const DisabledNoticeFrame = (props) => {
  const { notice, index } = props;
  const { noticeArray, setNoticeArray } = useContext(Context);
  const sendDate = dayjs(notice.sentAt).format('YYYY/MM/DD HH:mm:ss');

  const noticeTypeLabel = Object.values(NOTICE_TYPES).find((type) => type.value === notice.noticeTypeCode).label;

  return (
    <Paper sx={{ margin: '16px 0px', padding: '24px', backgroundColor: 'background.default' }} >
      <Stack spacing={2} marginBottom='34px'>
        <Stack direction='row-reverse'>
          <DeleteNoticeIcon
            index={index}
            noticeArray={noticeArray}
            setNoticeArray={setNoticeArray}
          />
          <Typography variant='caption13bold'>送信タイミング</Typography>
        </Stack>
        <Stack direction='row' spacing={2}>
          <Typography variant='body16'>{sendDate}</Typography>
          <Typography variant='body16'>{notice.isImmediate ? '送信済' : '送信予定'}</Typography>
        </Stack>
      </Stack>
      <Stack spacing={2} marginBottom='34px'>
        <Typography variant='caption13bold'>通告の種類</Typography>
        <Typography variant='caption13bold'>{
          notice.noticeCategoryCode === NOTICE_CATEGORIES.REGULATION ?
            '運転規制/解除（受領ボタンのタップが必要）' : '注意喚起情報'
        }</Typography>
        <Stack direction='row' alignItems='center' spacing={1}>
          <NoticeTypeIcon noticeTypeCode={notice.noticeTypeCode} sx={{ width: '24px', height: '24px' }} />
          <Typography variant='label14bold'>{noticeTypeLabel}</Typography>
        </Stack>
      </Stack>
      <Stack>
        <Stack direction='row' spacing={8} marginBottom='24px'>
          <Stack>
            <Typography variant='caption13bold'>線区</Typography>
            <Typography variant='body16'>{notice.sectionName}</Typography>
          </Stack>
          <Stack>
            <Typography variant='caption13bold'>区間</Typography>
            <Typography variant='body16'>{`${notice.startStationName}〜${notice.endStationName}`}</Typography>
          </Stack>
        </Stack>
        <Stack spacing={1}>
          <Typography variant='caption13bold'>事由</Typography>
          <Stack direction='row' spacing={1}>
            <ReasonIcon code={notice.reasonCode} />
            <Typography variant='label14bold'>
              {Object.values(REASONS).find((reason) => reason.value === notice.reasonCode)?.label}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default DisabledNoticeFrame;

DisabledNoticeFrame.propTypes = {
  notice: PropTypes.object,
  index: PropTypes.number,
};
